// Documents sub-mode inside Documents Editor — browse library + inline editor.

import { useState } from "react";
import { FIREFLY_TARGET_ATTR } from "@/lib/firefly/fireflyTargetConvention";
import { useAuth } from "@/contexts/AuthContext";
import { canEditDocuments } from "@/lib/document/documentRoles";
import { DocumentEditorWorkspace } from "./editor/DocumentEditorWorkspace";
import { DocumentLibrarySurface } from "./library/DocumentLibrarySurface";

export function DocumentsModePanel() {
  const auth = useAuth();
  const canEdit = canEditDocuments(auth);
  const [editing, setEditing] = useState(false);
  const [editDocumentId, setEditDocumentId] = useState<string | null>(null);
  const [libraryRefreshKey, setLibraryRefreshKey] = useState(0);

  function openEditor(documentId: string | null) {
    setEditDocumentId(documentId);
    setEditing(true);
  }

  function closeEditor() {
    setEditing(false);
    setEditDocumentId(null);
    setLibraryRefreshKey((n) => n + 1);
  }

  if (editing) {
    return (
      <div {...{ [FIREFLY_TARGET_ATTR]: "doc-documents-mode" }} className="space-y-4">
        <DocumentEditorWorkspace
          key={editDocumentId ?? "new"}
          initialDocumentId={editDocumentId}
          onBack={closeEditor}
        />
      </div>
    );
  }

  return (
    <div {...{ [FIREFLY_TARGET_ATTR]: "doc-documents-mode" }}>
      <DocumentLibrarySurface
        embedded
        includeDrafts={canEdit}
        canEdit={canEdit}
        onEditDocument={canEdit ? openEditor : undefined}
        useCategoryManager
        refreshKey={libraryRefreshKey}
      />
    </div>
  );
}
